import { publicApiFetch, catalogApiFetch } from '../admin/jscontrol/apiClient';
import { buildUserPasswordPayload } from '../admin/user/userUtils';

function normalizeRoles(data) {
  const list = Array.isArray(data?.data) ? data.data : Array.isArray(data) ? data : [];
  return list;
}

function findCustomerRoleId(roles) {
  const match = roles.find(
    (role) => String(role.Name ?? role.name ?? '').trim().toLowerCase() === 'customer'
  );
  const id = match?.RoleId ?? match?.roleId;
  return id != null ? Number(id) : null;
}

async function fetchRoleDropdown() {
  try {
    const { data } = await publicApiFetch('/User/GetRoleDropdown');
    return normalizeRoles(data);
  } catch {
    const { data } = await catalogApiFetch('/User/GetRoleDropdown');
    return normalizeRoles(data);
  }
}

export async function resolveCustomerRoleId() {
  const roles = await fetchRoleDropdown();
  return findCustomerRoleId(roles);
}

/** Storefront signup — reuses admin User/Create with Customer role. */
export async function createCustomerAccount({
  firstName,
  lastName,
  email,
  username,
  password,
  mobile = '',
}) {
  const roleId = await resolveCustomerRoleId();
  const trimmedUsername = String(username || '').trim();
  const trimmedEmail = String(email || '').trim();
  const trimmedMobile = String(mobile || '').trim();

  const payload = {
    FirstName: String(firstName || '').trim(),
    LastName: String(lastName || '').trim() || null,
    Username: trimmedUsername,
    ...buildUserPasswordPayload(password),
    Email: trimmedEmail,
    MobileNumber: trimmedMobile || null,
    Gender: null,
    DateOfBirth: null,
    RoleId: roleId,
    IsEmailVerified: false,
    IsMobileVerified: false,
    IsBlocked: false,
  };

  try {
    await publicApiFetch('/User/Create', { method: 'POST', data: payload });
  } catch {
    await catalogApiFetch('/User/Create', { method: 'POST', data: payload });
  }
}
